import type { IStorageController, IStore } from '@repo/common';
import { StorageController } from '@repo/sharedlib';
import { Store } from '../lib/stores/browser.store';

export class BrowserStorageController extends StorageController implements IStorageController {
  async loadAuthStore(_alertNoUpdatesservice: string): Promise<IStore> {
    // For browser, auth stores are not supported - return noop store
    return this.getNoopStore();
  }

  async loadPlainStore(filename: string): Promise<IStore> {
    // For browser, use browser store
    console.log(`Getting plain store from browserlib: ${filename}`);
    return new Store(filename);
  }

  async loadDurableStore(filename: string): Promise<IStore> {
    return this.loadPlainStore(filename);
  }

  isGlobal(filename: string): boolean {
    return filename.includes('.keychain') || filename === '.settings.dat';
  }

  /**
   * Override getStorageType to return 'plain' for keychain stores in browser
   */
  getStorageType(_filename: string): 'keychain' | 'plain' {
    // For browser, always return 'plain' since keychain is not supported
    return 'plain';
  }

  private getNoopStore(): IStore {
    // Return a NoopStore implementation
    return {
      clear: async () => {},
      reset: async () => {},
      set: async () => {},
      get: async () => undefined,
      delete: async () => true,
      entries: async () => [],
      reload: async () => {},
      save: async () => {}
    };
  }
}
